import { Utility } from '@app/models/utility';
import { Component, Input, OnInit } from '@angular/core';
import { RequestApproveSet } from '../request-approve/request-approve-datasource';

@Component({
  selector: 'app-actual-stamp-table',
  templateUrl: './actual-stamp-table.component.html',
  styleUrls: ['./actual-stamp-table.component.css']
})
export class ActualStampTableComponent implements OnInit {
  @Input() reportRecord: RequestApproveSet;

  targetDate: Date;
  dateDiff: Array<string> = ['前','','翌'];
  arriveStamps: Array<string> = [];
  leaveStamps: Array<string> = [];
  temporaryLeaveStamps: Array<string> = [];
  reenterStamps: Array<string> = [];
  indexArr: Array<number> = [];

  constructor() { }

  ngOnInit(): void {

    this.targetDate = this.reportRecord.targetDate;

    this.reportRecord.actualTimeStamps.forEach((stamp, index) => {
      if (stamp) {
        const stampDate = Utility.createDateFromText(stamp);
        const dateDiffIndex = Utility.diffDay(this.targetDate,stampDate) + 1;
        if (index === 0) {
          // 出社
          this.arriveStamps.push(this.dateDiff[dateDiffIndex] + Utility.convertDateToMinite(stampDate));
        } else if (index === 1) {
          // 退社
          this.leaveStamps.push(this.dateDiff[dateDiffIndex] + Utility.convertDateToMinite(stampDate));
        } else if (index % 2 === 0) {
          // 外出
          this.temporaryLeaveStamps.push(this.dateDiff[dateDiffIndex] + Utility.convertDateToMinite(stampDate));
        } else if (index % 2 === 1) {
          // 戻り
          this.reenterStamps.push(this.dateDiff[dateDiffIndex] + Utility.convertDateToMinite(stampDate));
        }
      }
    });
    // 見映えの為に最低4行は表示する。
    const maxLength = Math.max(...[this.arriveStamps.length, this.leaveStamps.length, this.temporaryLeaveStamps.length, this.reenterStamps.length]);
    this.indexArr = [...Array(maxLength)].map((_: undefined, index: number) => index);

  }

}
